import { listOfStringsTypeFiltersCombiner } from "./listOfStringsTypeFiltersCombiner";
import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const appliedProductFamilySelector = (state: RootState) => {
  const filters = resourceExplorerAppliedFiltersSelector(state);

  return listOfStringsTypeFiltersCombiner("product_family", filters);
};
